import { useCallback, useEffect } from 'react';

import { EventBus, EventType, TypeOfDataToNative } from 'scbk-services/event-bus/bus/event-bus.ts';

interface EventBusListenerProps {
    eventType: EventType;
    listener: (...args: unknown[]) => void | Promise<void>;
}

const useEventBusOn = ({ eventType, listener }: EventBusListenerProps): void => {
    useEffect(() => {
        const eventBus = EventBus.getInstance();
        eventBus.on(eventType, listener);
        return () => {
            eventBus.off(eventType, listener);
        };
    }, [eventType, listener]);
};

const useEventBusOnce = ({ eventType, listener }: EventBusListenerProps): void => {
    useEffect(() => {
        const eventBus = EventBus.getInstance();
        eventBus.once(eventType, listener);
    });
};

const useEventBusEmit = () => {
    return useCallback((eventType: EventType, ...args: unknown[]) => {
        const eventBus = EventBus.getInstance();
        eventBus.emit(eventType, ...args);
    }, []);
};

const useEventBusRemoveAllListeners = () => {
    return useCallback((eventType?: EventType) => {
        const eventBus = EventBus.getInstance();
        eventBus.removeAllListeners(eventType);
    }, []);
};

export {
    EventType,
    TypeOfDataToNative,
    useEventBusOn,
    useEventBusOnce,
    useEventBusEmit,
    useEventBusRemoveAllListeners,
};
